import { useMemo } from 'react';
import { sliceSegments } from './CbullshitcodingMarkup';
import type { ColoredSegment, DisplayLine } from './Cbullshitcoding.typing';

export function useCbullshitcodingCurrentLine(input: {
  strings: DisplayLine[];
  currentLineIndex: number;
  currentTypingLine: string;
}): DisplayLine | null {
  const strings = input.strings;
  const currentLineIndex = input.currentLineIndex;
  const currentTypingLine = input.currentTypingLine;

  return useMemo((): DisplayLine | null => {
    if (!currentTypingLine) {
      return null;
    }

    const sourceLine = strings[currentLineIndex];
    const fallbackSegments: ColoredSegment[] = [
      { text: currentTypingLine, color: null },
    ];

    return {
      plain: currentTypingLine,
      segments: sliceSegments({
        segments: sourceLine?.segments ?? fallbackSegments,
        maxVisible: currentTypingLine.length,
      }),
    };
  }, [currentLineIndex, currentTypingLine, strings]);
}
